import { render, staticRenderFns } from "./notificationComponent.vue?vue&type=template&id=eadef856&scoped=true&"
import script from "./notificationComponent.vue?vue&type=script&lang=js&"
export * from "./notificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./notificationComponent.vue?vue&type=style&index=0&id=eadef856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadef856",
  null
  
)

export default component.exports